// document.addEventListener("variant:change", (e) => {
//   setTimeout(() => {
//     const varr = e.detail.variant;
//     const compare_at_price = varr.compare_at_price;
//     const price = varr.price;

//     let percentage = 0;

//     if (compare_at_price && compare_at_price > price) {
//       percentage = Math.round(
//         ((compare_at_price - price) / compare_at_price) * 100
//       );
//     }
//       $(".cost-per-cup").hide();
//     if(percentage  > 0 ){
//       $(".cost-per-cup").html(percentage + "% OFF");
//       $(".cost-per-cup").show();
//     }
    

//   }, 0);
// });

document.addEventListener("variant:change", (e) => {
  const variant = e.detail.variant;
  if (!variant) return;

  const compareAtPrice = variant.compare_at_price;
  const price = variant.price;

  let percentage = 0;

  if (compareAtPrice && compareAtPrice > price) {
    percentage = Math.round(
      ((compareAtPrice - price) / compareAtPrice) * 100
    );
  }

  // Update only the discount badge
  document.querySelectorAll(".cost-per-cup:not(.per-cup)").forEach((badge) => {
    if (percentage > 0) {
      badge.textContent = percentage + "% OFF";
      badge.style.display = "";
    } else {
      badge.style.display = "none";
    }
  });
});
// $("document").ready(function(){
//     // scrolldown next section for landing page
//     $(".powerful-ingredients-sec .section-stack .custom-button a,.custom_vadam_why .media-with-text .media-with-text__content a,.buttom-full .media-with-text .media-with-text__content a").click(function () {
//     $("html, body").animate( {
//         scrollTop: $(".product-card-section").offset().top-100,
//       },
//       1000
//     );
//   });
//     if(window.location.pathname.includes('/products/')){ // to update delivery time on pdp
//         //console.log('product_page');
//         var $forward_d = $(".product-info").find(".product-info__liquid").find('span');
//         var w_content = $forward_d.html().split('|');
//         if( w_content.length >= 2){
//             // get content and days separately
//             var content = w_content[0];
//             var days = w_content[1];
//             const d = new Date();
//             // set future date
//             d.setDate(d.getDate() + parseInt(days));
//             const options = {
//                 weekday: "long",
//                 month: "long",
//                 day:"numeric"
//             };
//             // set the date format we want
//             var d_date = new Intl.DateTimeFormat("en-US", options).format(d);
//             // push the changes
//             $forward_d.html(content + ' ' + d_date);
//         }
//     }
//     // mega_menu sub_menu selection 
//     $("li.main_menu_cu").on("click", function(){
//         let $child_mm = $(this).find("ul.sub_menu_cu");
//         // check the sub_menu item exist
//         if($child_mm.length > 0){
//             $("li.main_menu_cu a span").css('color', '#161616');
//             $(this).children("a").children("span").css('color', '#AB8744');
//             $("ul.sub_menu_cu").hide();
//             $(this).find("ul.sub_menu_cu").show();
//         }
//     });
//     // product-card-boco ajax
//     attachAtcAjaxEvents(); // fire once on page load

//     // for sort list change event
//     document.addEventListener("listbox:change", function(){
//         setTimeout(function(){
//             attachAtcAjaxEvents();
//         }, 1000);
//     });
//     document.addEventListener('click', function(event) {
//         // for filter checkbox
//         if( event.target.matches("input.checkbox") ) {
//             if( event.target.parentElement.matches("div.checkbox-container")){
//                 setTimeout(function(){
//                     attachAtcAjaxEvents();
//                 }, 1000);
//             }
//         }
//         // for removing individual filters
//         if( event.target.matches("a.tap-area") ) {
//             if( event.target.parentElement.matches("div.removable-facet") ){
//                 setTimeout(function(){
//                     attachAtcAjaxEvents();
//                 }, 1000);
//             }
//         }
//         // for clear all
//         if( event.target.matches("span.link") ) {
//             if( event.target.parentElement.matches("a.facet-clear-all") ){
//                 setTimeout(function(){
//                     attachAtcAjaxEvents();
//                 }, 1000);
//             }
//         }
//         // for view more
//         if( event.target.matches("button#load-more-btn") ) {
//             if( event.target.parentElement.matches("div.more-btn-div") ){
//                 setTimeout(function(){
//                     attachAtcAjaxEvents();
//                 }, 1000);
//             }
//         }
//     });
//     function attachAtcAjaxEvents() {
//         $('.add_to_cart_form_cu').on('submit', function(event){
//             // get data
//             var $atc_btn = $(this).find(".add-to-cart-button");
//             var $t = $(".header__cart-count").find(".count-bubble");
//             // disable atc button and cart count
//             $atc_btn.prop("disabled", true);
//             $t.css("opacity", "0");
//             event.preventDefault();
//             $.ajax({
//                 type: 'POST',
//                 url: '/cart/add.js',
//                 data: $(this).serialize(),
//                 dataType: 'json',
//                 success: function() {
//                     var item_count;
//                     $.when( 
//                         jQuery.getJSON('/cart.js', function(cart) {
//                             item_count = cart.item_count;
//                             let cartData = cart.items;
//                             document.dispatchEvent(new CustomEvent('cart:build' ,{
//                                     bubbles: true
//                                 }
//                             )); 
//                             document.dispatchEvent(new CustomEvent('cart:refresh', {
//                                 bubbles: true,
//                                 detail: cartData
//                             })); 
        
//                             // get cart drawer 
//                             document.dispatchEvent(new CustomEvent('variant:add', {
//                                 bubbles: true,
//                             }));
//                         })
//                     ).then(function(){
//                         setTimeout(function(){
                            
//                             // update cart count + enable opacity + enable atc btn
//                             $t.html(item_count);
//                             $t.css("opacity", "1");
//                             //$t_in.css("opacity", "1");
//                             $atc_btn.prop("disabled", false);
        
//                         }, 2000);
        
//                     });
//                 },
//                 error: function(e) {
//                     // for further debugging
//                     console.log(e.responseJSON);
//                     // restore button and count
//                     $t.css("opacity", "1");
//                     //$t_in.css("opacity", "1");
//                     $atc_btn.prop("disabled", false);
//                 }
//             });
        
//         }); 
//     }
//     $(".see-more").on("click", function(event) {
//         const textContainer = document.querySelector('.text-container');
//         const textContent = document.querySelector('.text-content');
//         const seeMore = document.querySelector('.see-more');
//         if (seeMore.textContent === "...read more") {
//             textContent.style.display = 'block';
//             textContent.style.webkitBoxOrient = 'unset';
//             textContent.style.webkitLineClamp = 'unset';
//             textContent.style.maxHeight = 'none';
//             seeMore.style.display = 'none';
//         } 
//     });
//     if(window.location.pathname.indexOf('/products/') == 0){ 
//         var descr_cont = $(".product-info").find(".product-info__description").find(".text-content").text().length;
//             if (descr_cont < 200) {
//                 $('.see-more').css({
//                     'display': 'none'
//                 });
//                 $('.text-content').css({
//                     '-webkit-line-clamp': 'unset',
//                     'max-height': 'unset'
//                 });
//             }
//     }
// });
// $(document).ready(function() {
//     $(".new-see").on("click", function() {
//         const textContainer = $(this).closest(".text-container");
//         const textContent = textContainer.find(".text-content");
//         const seeMore = $(this);
//         if (seeMore.text() === "...read more") {
//             textContent.css({
//                 'display': 'block',
//                 '-webkit-box-orient': 'unset',
//                 '-webkit-line-clamp': 'unset',
//                 'max-height': 'none'
//             });
//             seeMore.hide(); // Hide "Read More" after expanding text
//         }
//     });
//     if (window.location.pathname.indexOf('/products/') === 0) { 
//         $(".text-container").each(function() {
//             var descr_cont = $(this).find(".text-content").text().length;
//             if (descr_cont < 100) {
//                 $(this).find('.new-see').hide();
//                 $(this).find('.text-content').css({
//                     '-webkit-line-clamp': 'unset',
//                     'max-height': 'unset'
//                 });
//             }
//         });
//     }
//     $("variant-picker .input-label-wrapper").click(function () {
//         $("variant-picker .input-label-wrapper").removeClass("is-selected")
//         if ($(this).find("span.variant-badge").length) {
//             $(this).addClass("is-selected")
//         }
//     })
//    //Code for showing price on add to cart button and try now button
//    if ($('body').hasClass("template-new-pdp")) {
//     function priceAddToCart() {
//      let mprice;
//         if ($(".product price-list .selling-price.money").length) {
//             mprice=$(".product price-list .selling-price.money").text()
//         }
//         else{
//              mprice=$(".product price-list sale-price .money").text()
//         }
//      let newTxt=" - "+mprice ;
//      if ($(".product buy-buttons button[type='submit'] span#v-price").length) {
//         $(".product buy-buttons button[type='submit'] span#v-price").text(newTxt)
//      }
//      else{
//          $(".product buy-buttons button[type='submit'] div").append(`<span id="v-price">${newTxt}</span>`)
//      }
//      if ($(".product button[type='submit'].try-now-button span#v-price").length) {
//         $(".product button[type='submit'].try-now-button span#v-price").text(newTxt)
//      }
//      else{
//          $(".product button[type='submit'].try-now-button").append(`<span id="v-price">${newTxt}</span>`)
//      }
//     }
 
//     // if (!document.body.classList.contains('template-new-pdp-26nov2025')) {
//           var Interval = setInterval(loopSub, 800);
//     // }
// function loopSub(){
// if($(".loop-widget-purchase-options-container").length > 0){
//     var comparePrice =$(".mrp-price-if-any").text();
//     if(comparePrice != "" || comparePrice != undefined || comparePrice != null){
//         // $("div[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price-each-container .loop-widget-purchase-option-price").before('<div class="loop-widget-purchase-option-compare-at-price">'+comparePrice+'</div>');
//         var $priceContainer = $("div[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price-each-container");
//         var $comparePrice = $priceContainer.find(".loop-widget-purchase-option-compare-at-price");

//         if ($comparePrice.length) {
//             $comparePrice.text(comparePrice);
//         } else {
//             $priceContainer.find(".loop-widget-purchase-option-price")
//                 .before('<div class="loop-widget-purchase-option-compare-at-price">' + comparePrice + '</div>');
//         }
//         $("div[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price-each-container .loop-widget-purchase-option-compare-at-price").text(comparePrice);
//     }
//     clearInterval(Interval);
//     $(".loop-widget-sp-selector-container select").attr("aria-label", "Frequency selector");
//     var mprice = $(".product price-list .money").first().text();
//     if ( $(".product buy-buttons button[type='submit'] div span#v-price").length) {
//         $(".product buy-buttons button[type='submit'] div span#v-price").text(" - "+mprice);
//     }
//     else{
//         $(".product buy-buttons button[type='submit'] div").append(`<span id="v-price"> - ${mprice}</span>`);
//     }
//       $(".loop-widget-purchase-options-container").click(function () {
    
//         let txt = $(".loop-widget-purchase-option-selected").find(".loop-widget-purchase-option-price").text();
//         $(".product price-list .money").first().text(txt);
//           $(".product buy-buttons button[type='submit'] span#v-price").text(" - "+txt)
//           $(".product button[type='submit'].try-now-button span#v-price").text(" - "+txt);   
 
//            if ($(".product buy-buttons button[type='submit'] span#v-price").length) {
//         $(".product buy-buttons button[type='submit'] span#v-price").text(" - "+txt)
//      }
//      else{
//          $(".product buy-buttons button[type='submit'] div").append(`<span id="v-price"> - ${txt}</span>`)
//      }
//      console.log(txt);
//      console.log(comparePrice);

//       let finaltx = parseFloat(txt.replace('£',''));
//         let comparePr = parseFloat(comparePrice.replace('£',''));

//         console.log("finalPric==>"+finaltx);
//           console.log("comparePric==>"+comparePr);
//           if (comparePr > finaltx) {
//             let discountt = comparePr - finaltx;
//             let discountPercents = Math.round((discountt / comparePr) * 100);

//             console.log(discountPercents + "% OFF");
//             setTimeout(function(){
//               $(".discount-if-any.cost-per-cup").text(discountPercents + "% OFF");
//             }, 100);
//           }

//      });
     
//      let finaltext = $(".loop-widget-purchase-option-selected").find(".loop-widget-purchase-option-price").text();
//       $(".product price-list .selling-price.money").text(finaltext);
//      let finaltex = parseFloat(finaltext.replace('£',''));
//         let comparePri = parseFloat(comparePrice.replace('£',''));

//         console.log("finalPric==>"+finaltex);
//           console.log("comparePric==>"+comparePri);
//           if (comparePri > finaltex) {
//             let discount = comparePri - finaltex;
//             let discountPercent = Math.round((discount / comparePri) * 100);

//             console.log(discountPercent + "% OFF");
//             // setTimeout(function(){
//               $(".discount-if-any.cost-per-cup").text(discountPercent + "% OFF");
//             // }, 50);
//           }

//     }
// }
//     priceAddToCart();
//      document.addEventListener("variant:change", (e) => {
//        setTimeout(() => {
//         priceAddToCart();
//         loopSub();
//        }, 0);
//      });
//     window.addEventListener("beforeunload", function (e) {
//      const labels = document.querySelectorAll('.variant-picker__option-values .block-swatch');
//         if (labels.length >= 3) {
//          $(".variant-picker__option-values label.block-swatch").eq(1).trigger("click"); 
//         }
//     });
//     }
// });
// document.querySelectorAll(".shopify-section--faq details.accordion").forEach((el, index, allAccordions) => { // close accordions automatically when the clicked one is open
//     el.addEventListener("click", function (event) {
//         event.preventDefault();
//         // Close all other accordions
//         allAccordions.forEach((item) => {
//             if (item !== this) {
//                 item.removeAttribute("open");
//                 item.setAttribute("aria-expanded", "false");
//             }
//         });
//         // Open the clicked accordion
//         this.setAttribute("open", "");
//         this.setAttribute("aria-expanded", "true");
//     });
// });
// var loadNector = setInterval(checkNectorShadow, 200);
// function checkNectorShadow() {
//   const host = document.querySelector('#nector-reviews');
//   if (!host) return;
//   const shadow = host.shadowRoot || host.attachShadow?.({ mode: 'open' });
//   if (!shadow) return;
//   const container = shadow.querySelectorAll('.nector-container .nector-reviews');
//   const imgs = shadow.querySelectorAll('.react-multi-carousel-track .react-multi-carousel-item img');
//   const shorts = shadow.querySelectorAll('select.nector-reviews-sorter');
//   const button = shadow.querySelectorAll('.react-multi-carousel-list button');
//   if (imgs.length > 0 || container.length > 0) {
//     imgs.forEach((img, i) => {
//       img.setAttribute('alt', 'Customer review image ' + (i + 1));
//       img.setAttribute('loading', 'lazy');
//     });
//     shorts.forEach(sel => {
//       sel.setAttribute('aria-label', 'Review sort dropdown');
//     });
//     setTimeout(function(){
//     button.forEach(btn => {
//       btn.setAttribute('aria-label', 'Review button');
//     });
//     }, 2500);
//     setTimeout(() => {
//      clearInterval(loadNector);
//     }, 5000);
//   }
// }
// var loadKlaviyo = setInterval(checkKlaviyo, 200);
// function checkKlaviyo() {
//   if ($('.needsclick.kl-private-reset-css-Xuajs1').length > 2) {    
//     $('.needsclick.kl-private-reset-css-Xuajs1 img').attr("alt", "klaviyo popup image");
//     setTimeout(() => {
//       clearInterval(loadKlaviyo);
//     }, 10000);
//   }
// }









// // script for swap-upsell [21 jan 2026]

// document.addEventListener('click', async function (event) {
//   const button = event.target.closest('.upgrade-btn');
//   if (!button) return;

//   event.preventDefault();

//   if (button.classList.contains('loading')) return;
//   button.classList.add('loading');
//   button.disabled = true;

//   const lineKey = button.dataset.line;
//   const qty = parseInt(button.dataset.qty, 10) || 1;
//   const upgradeVariantId = Number(button.dataset.upgrade);
//   const oldVariantId = Number(button.dataset.oldVariant);
//   const gifts = JSON.parse(button.dataset.gifts || '[]');
//   const sellingPlanId = button.dataset.sellingPlan
//     ? Number(button.dataset.sellingPlan)
//     : null;

//   try {
//     //  ADD UPGRADE 
//     const upgradeRes = await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: upgradeVariantId,
//         quantity: qty,
//         properties: {
//           _swap: 'true'
//         },
//         ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
//       })
//     });

//     if (!upgradeRes.ok) throw new Error('Upgrade add failed');

//     //   GET CART 
//    // let existingVariantIds = [];
//    // if (gifts.length) {
//     //  const cartRes = await fetch('/cart.js');
//     //  const cart = await cartRes.json();
//      // existingVariantIds = cart.items.map(item => item.variant_id);
//    // }


//    const cartRes = await fetch('/cart.js');
// const cart = await cartRes.json();

// // map variant_id → full cart item
// const cartItemMap = new Map();

// cart.items.forEach(item => {
//   cartItemMap.set(item.variant_id, item);
// });


//     //  ADD GIFTS 
//   for (const giftId of gifts) {
//   const variantId = Number(giftId);

//   const existingItem = cartItemMap.get(variantId);

//   const properties = {
//     _gift: 'true',
//     _free_gift_swap: 'true',
//     _parent_variant_id: String(upgradeVariantId),
//     _parent_title: button.dataset.parentTitle || 'your subscription'
//   };

//   console.log('Processing gift:', {
//     variantId,
//     exists: !!existingItem
//   });

// if (existingItem) {

//   await fetch('/cart/change.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({
//       id: existingItem.key,
//       quantity: 0
//     })
//   });

//   await fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({
//       id: variantId,
//       quantity: 1,
//       properties
//     })
//   });

//   console.log('ADDING GIFT WITH PROPERTIES:', JSON.stringify(properties, null, 2));


//   continue;
// }


//   const giftRes = await fetch('/cart/add.js', {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify({
//       id: variantId,
//       quantity: 1,
//       properties
//     })
//   });

//   if (!giftRes.ok) {
//     console.warn('Gift skipped (likely out of stock):', variantId);
//   }
// }


//     //  REMOVE OLD ITEM LAST
//     await fetch('/cart/update.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         updates: {
//           [oldVariantId]: 0
//         }
//       })
//     });
//     // await fetch('/cart/change.js', {
//     //   method: 'POST',
//     //   headers: { 'Content-Type': 'application/json' },
//     //   body: JSON.stringify({ id: lineKey, quantity: 0 })
//     // });


//     //  REFRESH CART 
//     if (window.location.pathname === '/cart') {
//       window.location.reload();
//     } else {
//       await dispatchCartChange('swap');
//       document.dispatchEvent(new Event('cart:refresh'));
//     }

//   } catch (error) {
//     console.error('Upgrade swap failed:', error);
//     alert('Something went wrong while upgrading. Please try again.');
//   } finally {
//     button.classList.remove('loading');
//     button.disabled = false;
//   }
// });






// //remove gifts item too with main product

// async function removeLinkedGifts(parentVariantId) {
//   const cartRes = await fetch('/cart.js');
//   const cart = await cartRes.json();

//   const updates = {};

//   cart.items.forEach(item => {

//     const isFreeGift =  item.properties?._free_gift_swap === true || item.properties?._free_gift_swap === "true" ;

//     if (
//      isFreeGift &&
//       Number(item.properties._parent_variant_id) === Number(parentVariantId)
//     ) {
//       updates[item.key] = 0;
//     }
  
 
//   });

//   if (Object.keys(updates).length) {
//     await fetch('/cart/update.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ updates })
//     });
//   }
// }






// //i have made similar different button for removing main swap product here is its event handling 

// document.addEventListener('click', async (e) => {
//   const btn = e.target.closest('.remove-swap-item');
//   if (!btn) return;

//   e.preventDefault();

//   const lineKey = btn.dataset.lineKey;
//   const parentVariantId = btn.dataset.variantId;

//   try {
//     // remove gifts first
//     await removeLinkedGifts(parentVariantId);

//     // then remove main product
//     await fetch('/cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: lineKey, quantity: 0 })
//     });

//     if (window.location.pathname === '/cart') {
//       window.location.reload();
//     } else {
//       // document.dispatchEvent(new Event('cart:refresh'));
//       await dispatchCartChange('swap');
//       document.dispatchEvent(new Event('cart:refresh'));
//     }
//   } catch (err) {
//     console.error('Swap remove failed', err);
//   }
// });



// async function dispatchCartChange(baseEvent = 'custom') {
//   const res = await fetch('/cart.js');
//   const cart = await res.json();

//   document.dispatchEvent(
//     new CustomEvent('cart:change', {
//       bubbles: true,
//       detail: {
//         cart,
//         baseEvent
//       }
//     })
//   );
// }

// // Swap upsell related script end

// (function () {
//   window.addEventListener("load", function () {
//     window.__ATC_QUEUE__ = [];
//     window.__ATC_BUSY__ = false;
//     const originalFetch = window.fetch;
//     window.fetch = async function (...args) {
//       const url = args[0];
//       if (typeof url === "string" && url.includes("/cart/add")) {
//         return new Promise(async (resolve, reject) => {
//           try {
//             const response = await originalFetch.apply(this, args);
//             const cloned = response.clone();
//             const data = await cloned.json();
//             document.dispatchEvent(new CustomEvent("atc:done", {
//               detail: { cart: data }
//             }));
//             setTimeout(() => {
//               window.dispatchEvent(new CustomEvent("atc:after"));
//             }, 100);
//             resolve(response);
//           } catch (err) {
//             reject(err);
//           }
//         });
//       }
//       return originalFetch.apply(this, args);
//     };
//   });
// })();


// $("document").ready(function(){
// //*****************  Collection page Load Yotpo Reviews start  *************************/ 
// const wrapper = document.querySelector("#wizzy-shopify-collection-page-wrapper");

// if (wrapper) {
//   const observer = new MutationObserver(() => {
//     const widgets = wrapper.querySelectorAll(".yotpo-widget-instance");

//     if (widgets.length > 1) {
//       window.yotpoWidgetsContainer?.initWidgets();

//       // Observer stop
//       observer.disconnect();
//     }
//   });

//   observer.observe(wrapper, {
//     childList: true,
//     subtree: true
//   });

//     document.body.addEventListener("click", function (e) {
//       if (e.target.closest(".wizzy-facet-body")) {
//         window.yotpoWidgetsContainer?.initWidgets();
//         setTimeout(()=> {
//           window.yotpoWidgetsContainer?.initWidgets();
//         }, 500);
//       }
//     });

// }
// //*****************  Collection page Load Yotpo Reviews end  *************************/ 
// });


$("document").ready(function(){
    // scrolldown next section for landing page
    $(".powerful-ingredients-sec .section-stack .custom-button a,.custom_vadam_why .media-with-text .media-with-text__content a,.buttom-full .media-with-text .media-with-text__content a").click(function () {
    $("html, body").animate( {
        scrollTop: $(".product-card-section").offset().top-100,
      },
      1000
    );
  });
    if(window.location.pathname.includes('/products/')){ // to update delivery time on pdp
        //console.log('product_page');
       
        let tempSuff = $(".template_suffix").attr("template");
        if(tempSuff == "new-pdp-17-aug-2026"){
            var $forward_d = $(".product-info").find(".product-info__liquid").find('.todo');
        }
        else{
            var $forward_d = $(".product-info").find(".product-info__liquid").find('span');
        }
        var w_content = $forward_d.html().split('|');
        if( w_content.length >= 2){
            // get content and days separately
            var content = w_content[0];
            var days = w_content[1];
            const d = new Date();
            // set future date
            d.setDate(d.getDate() + parseInt(days));
            const options = {
                weekday: "long",
                month: "long",
                day:"numeric"
            };
            // set the date format we want
            var d_date = new Intl.DateTimeFormat("en-US", options).format(d);
            // push the changes
            $forward_d.html(content + ' ' + d_date);
        }
    }
    // mega_menu sub_menu selection 
    $("li.main_menu_cu").on("click", function(){
        let $child_mm = $(this).find("ul.sub_menu_cu");
        // check the sub_menu item exist
        if($child_mm.length > 0){
            $("li.main_menu_cu a span").css('color', '#161616');
            $(this).children("a").children("span").css('color', '#AB8744');
            $("ul.sub_menu_cu").hide();
            $(this).find("ul.sub_menu_cu").show();
        }
    });
    // product-card-boco ajax
    attachAtcAjaxEvents(); // fire once on page load

    // for sort list change event
    document.addEventListener("listbox:change", function(){
        setTimeout(function(){
            attachAtcAjaxEvents();
        }, 1000);
    });
    document.addEventListener('click', function(event) {
        // for filter checkbox
        if( event.target.matches("input.checkbox") ) {
            if( event.target.parentElement.matches("div.checkbox-container")){
                setTimeout(function(){
                    attachAtcAjaxEvents();
                }, 1000);
            }
        }
        // for removing individual filters
        if( event.target.matches("a.tap-area") ) {
            if( event.target.parentElement.matches("div.removable-facet") ){
                setTimeout(function(){
                    attachAtcAjaxEvents();
                }, 1000);
            }
        }
        // for clear all
        if( event.target.matches("span.link") ) {
            if( event.target.parentElement.matches("a.facet-clear-all") ){
                setTimeout(function(){
                    attachAtcAjaxEvents();
                }, 1000);
            }
        }
        // for view more
        if( event.target.matches("button#load-more-btn") ) {
            if( event.target.parentElement.matches("div.more-btn-div") ){
                setTimeout(function(){
                    attachAtcAjaxEvents();
                }, 1000);
            }
        }
    });
    function attachAtcAjaxEvents() {
        $('.add_to_cart_form_cu').on('submit', function(event){
            // get data




               if($(this).hasClass('loop_subscription_prod')){
                  var $form = $(this);
                  var $atc_btn = $form.find(".add-to-cart-button");
                  var $t = $(".header__cart-count").find(".count-bubble");

                  $atc_btn.prop("disabled", true);
                  $t.css("opacity", "0");

                  event.preventDefault();

                  $.ajax({
                      url: '/products/ashwagandha-coffee',
                      type: 'GET',
                      success: function (html) {

                          const $html = $(html);
                          const sellingPlan = $html.find('input[name="selling_plan"]').val();
                    
                          const payload = {
                              items: [{
                                  id: 54489348309283,
                                  quantity: 1,
                                  selling_plan: 8320385315,
                                  properties: {}
                              }]
                          };

                          $.ajax({
                              url: "/cart/add.js",
                              type: "POST",
                              contentType: "application/json",
                              data: JSON.stringify(payload),
                              dataType: "json",

                              success: function () {

                                  var item_count;

                                  $.when(
                                      $.getJSON('/cart.js', function (cart) {

                                          item_count = cart.item_count;
                                          let cartData = cart.items;

                                          document.dispatchEvent(new CustomEvent('cart:build', {
                                              bubbles: true
                                          }));

                                          document.dispatchEvent(new CustomEvent('cart:refresh', {
                                              bubbles: true,
                                              detail: cartData
                                          }));

                                          document.dispatchEvent(new CustomEvent('variant:add', {
                                              bubbles: true
                                          }));

                                      })
                                  ).then(function () {

                                      setTimeout(function () {

                                          $t.html(item_count);
                                          $t.css("opacity", "1");
                                          $atc_btn.prop("disabled", false);

                                      }, 2000);

                                  });

                              },

                              error: function (e) {

                                  console.error(e);

                                  $t.css("opacity", "1");
                                  $atc_btn.prop("disabled", false);

                              }
                          });

                      },

                      error: function (xhr, status, error) {

                          console.error(error);
                          $t.css("opacity", "1");
                          $atc_btn.prop("disabled", false);

                      }
                  });

                  return false;
            }
            else{
            var $atc_btn = $(this).find(".add-to-cart-button");
            var $t = $(".header__cart-count").find(".count-bubble");
            // disable atc button and cart count
            $atc_btn.prop("disabled", true);
            $t.css("opacity", "0");
            event.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: $(this).serialize(),
                dataType: 'json',
                success: function() {
                    var item_count;
                    $.when( 
                        jQuery.getJSON('/cart.js', function(cart) {
                            item_count = cart.item_count;
                            let cartData = cart.items;
                            document.dispatchEvent(new CustomEvent('cart:build' ,{
                                    bubbles: true
                                }
                            )); 
                            document.dispatchEvent(new CustomEvent('cart:refresh', {
                                bubbles: true,
                                detail: cartData
                            })); 
        
                            // get cart drawer 
                            document.dispatchEvent(new CustomEvent('variant:add', {
                                bubbles: true,
                            }));
                        })
                    ).then(function(){
                        setTimeout(function(){
                            
                            // update cart count + enable opacity + enable atc btn
                            $t.html(item_count);
                            $t.css("opacity", "1");
                            //$t_in.css("opacity", "1");
                            $atc_btn.prop("disabled", false);
        
                        }, 2000);
        
                    });
                },
                error: function(e) {
                    // for further debugging
                    console.log(e.responseJSON);
                    // restore button and count
                    $t.css("opacity", "1");
                    //$t_in.css("opacity", "1");
                    $atc_btn.prop("disabled", false);
                }
            });

          }



        
        }); 
    }
    $(document).ready(function() {
    $(".see-more").on("click", function(event) {
        $(".product-info__description .text-content").removeClass("is-truncated");
        $(this).hide();
    });
});
    // $(".see-more").on("click", function(event) {
    //     const textContainer = document.querySelector('.text-container');
    //     const textContent = document.querySelector('.text-content');
    //     const seeMore = document.querySelector('.see-more');
    //     if (seeMore.textContent === "...read more") {
    //         textContent.style.display = 'block';
    //         textContent.style.webkitBoxOrient = 'unset';
    //         textContent.style.webkitLineClamp = 'unset';
    //         textContent.style.maxHeight = 'none';
    //         seeMore.style.display = 'none';
    //     } 
    // });
    // if(window.location.pathname.indexOf('/products/') == 0){ 
    //     var descr_cont = $(".product-info").find(".product-info__description").find(".text-content").text().length;
    //         if (descr_cont < 200) {
    //             $('.see-more').css({
    //                 'display': 'none'
    //             });
    //             $('.text-content').css({
    //                 '-webkit-line-clamp': 'unset',
    //                 'max-height': 'unset'
    //             });
    //         }
    // }
});

// document.addEventListener('DOMContentLoaded', () => {
//   // 1. READ MORE CLICK
//   document.querySelectorAll('.see-more').forEach(button => {
//     button.addEventListener('click', function (e) {
//       e.preventDefault();
//       const container = this.closest('.product-info__description');
//       if (!container) return;

//       const proseDiv = container.querySelector('.prose.text-content');
//       const seeLessBtn = container.querySelector('.see-less');

//       // Description Expand karein
//       if (proseDiv) proseDiv.classList.remove('is-truncated');

//       // Buttons Toggle karein
//       this.classList.add('is-hidden');
//       this.style.display = 'none';

//       if (seeLessBtn) {
//         seeLessBtn.classList.remove('is-hidden');
//         seeLessBtn.style.display = 'inline-block';
//       }
//     });
//   });

//   // 2. READ LESS CLICK
//   document.querySelectorAll('.see-less').forEach(button => {
//     button.addEventListener('click', function (e) {
//       e.preventDefault();
//       const container = this.closest('.product-info__description');
//       if (!container) return;

//       const proseDiv = container.querySelector('.prose.text-content');
//       const seeMoreBtn = container.querySelector('.see-more');

//       // Description Truncate karein
//       if (proseDiv) proseDiv.classList.add('is-truncated');

//       // Buttons Toggle karein
//       this.classList.add('is-hidden');
//       this.style.display = 'none';

//       if (seeMoreBtn) {
//         // 'is-hidden' class remove karna ZARURI hai
//         seeMoreBtn.classList.remove('is-hidden');
//         seeMoreBtn.style.display = 'inline-block';
//       }
//     });
//   });
// });
document.addEventListener('DOMContentLoaded', () => {
  const initDescriptionTruncate = () => {
    document.querySelectorAll('.product-info__description').forEach(container => {
      const proseDiv = container.querySelector('.text-content');
      const seeMoreBtn = container.querySelector('.see-more');
      const seeLessBtn = container.querySelector('.see-less');

      if (!proseDiv) return;

      // Check if text content exceeds 3 lines
      const isOverflowing = proseDiv.scrollHeight > proseDiv.clientHeight + 2;

      if (isOverflowing) {
        container.classList.add('has-overflow');
        if (seeMoreBtn) {
          seeMoreBtn.classList.remove('is-hidden');
          seeMoreBtn.style.display = ''; // Inline style clear karein
        }
      } else {
        // Text 3 lines ya usse kam hai
        proseDiv.classList.remove('is-truncated');
        container.classList.remove('has-overflow');
        
        if (seeMoreBtn) {
          seeMoreBtn.classList.add('is-hidden');
          seeMoreBtn.style.display = 'none';
        }
        if (seeLessBtn) {
          seeLessBtn.classList.add('is-hidden');
          seeLessBtn.style.display = 'none';
        }
      }
    });
  };

  // Run on page load & resize
  initDescriptionTruncate();
  window.addEventListener('resize', initDescriptionTruncate);

  // 1. READ MORE CLICK
  document.querySelectorAll('.see-more').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const container = this.closest('.product-info__description');
      if (!container) return;

      const proseDiv = container.querySelector('.text-content');
      const seeLessBtn = container.querySelector('.see-less');

      // Expand Description
      if (proseDiv) proseDiv.classList.remove('is-truncated');

      // Read More Hide karein
      this.classList.add('is-hidden');
      this.style.display = 'none';

      // Read Less Show karein
      if (seeLessBtn) {
        seeLessBtn.classList.remove('is-hidden');
        seeLessBtn.style.display = 'inline-block';
      }
    });
  });

  // 2. READ LESS CLICK
  document.querySelectorAll('.see-less').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const container = this.closest('.product-info__description');
      if (!container) return;

      const proseDiv = container.querySelector('.text-content');
      const seeMoreBtn = container.querySelector('.see-more');

      // Truncate Description
      if (proseDiv) proseDiv.classList.add('is-truncated');

      // Read Less Hide karein
      this.classList.add('is-hidden');
      this.style.display = 'none';

      // Read More Show karein
      if (seeMoreBtn) {
        seeMoreBtn.classList.remove('is-hidden');
        seeMoreBtn.style.display = 'inline-block'; // Inline display show set karein
      }
    });
  });
});

$(document).ready(function() {
    $(".new-see").on("click", function() {
        const textContainer = $(this).closest(".text-container");
        const textContent = textContainer.find(".text-content");
        const seeMore = $(this);
        if (seeMore.text() === "...read more") {
            textContent.css({
                'display': 'block',
                '-webkit-box-orient': 'unset',
                '-webkit-line-clamp': 'unset',
                'max-height': 'none'
            });
            seeMore.hide(); // Hide "Read More" after expanding text
        }
    });
    if (window.location.pathname.indexOf('/products/') === 0) { 
        $(".text-container").each(function() {
            var descr_cont = $(this).find(".text-content").text().length;
            if (descr_cont < 100) {
                $(this).find('.new-see').hide();
                $(this).find('.text-content').css({
                    '-webkit-line-clamp': 'unset',
                    'max-height': 'unset'
                });
            }
        });
    }
    $("variant-picker .input-label-wrapper").click(function () {
        $("variant-picker .input-label-wrapper").removeClass("is-selected")
        if ($(this).find("span.variant-badge").length) {
            $(this).addClass("is-selected")
        }
    })
   //Code for showing price on add to cart button and try now button
   if ($('body').hasClass("template-new-pdp")) {
    function priceAddToCart() {
     let mprice;
        if ($(".product price-list .selling-price.money").length) {
            mprice=$(".product price-list .selling-price.money").text()
        }
        else{
             mprice=$(".product price-list sale-price .money").text()
        }
     let newTxt=" - "+mprice ;
     if ($(".product buy-buttons button[type='submit'] span#v-price").length) {
        $(".product buy-buttons button[type='submit'] span#v-price").text(newTxt)
     }
     else{
         $(".product buy-buttons button[type='submit'] div").append(`<span id="v-price">${newTxt}</span>`)
     }
     if ($(".product button[type='submit'].try-now-button span#v-price").length) {
        $(".product button[type='submit'].try-now-button span#v-price").text(newTxt)
     }
     else{
         $(".product button[type='submit'].try-now-button").append(`<span id="v-price">${newTxt}</span>`)
     }
    }
 
    // if (!document.body.classList.contains('template-new-pdp-26nov2025')) {
          var Interval = setInterval(loopSub, 800);
    // }
function loopSub(){
if($(".loop-widget-purchase-options-container").length > 0){
    var comparePrice =$(".mrp-price-if-any").text();
    if(comparePrice != "" || comparePrice != undefined || comparePrice != null){
        // $("div[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price-each-container .loop-widget-purchase-option-price").before('<div class="loop-widget-purchase-option-compare-at-price">'+comparePrice+'</div>');
        var $priceContainer = $("div[data-loop-widget-onetime-purchase-option] .loop-widget-purchase-option-price-each-container");
        var $comparePrice = $priceContainer.find(".loop-widget-purchase-option-compare-at-price");

        if ($comparePrice.length) {
            $comparePrice.text(comparePrice);
        } else {
            $priceContainer.find(".loop-widget-purchase-option-price")
                .before('<div class="loop-widget-purchase-option-compare-at-price">' + comparePrice + '</div>');
        }
        $("div[data-loop-widget-selling-plan-group] .loop-widget-purchase-option-price-each-container .loop-widget-purchase-option-compare-at-price").text(comparePrice);
    }
    clearInterval(Interval);
    $(".loop-widget-sp-selector-container select").attr("aria-label", "Frequency selector");
    var mprice = $(".product price-list .money").first().text();
    if ( $(".product buy-buttons button[type='submit'] div span#v-price").length) {
        $(".product buy-buttons button[type='submit'] div span#v-price").text(" - "+mprice);
    }
    else{
        $(".product buy-buttons button[type='submit'] div").append(`<span id="v-price"> - ${mprice}</span>`);
    }
      $(".loop-widget-purchase-options-container").click(function () {
    
        let txt = $(".loop-widget-purchase-option-selected").find(".loop-widget-purchase-option-price").text();
        $(".product price-list .money").first().text(txt);
          $(".product buy-buttons button[type='submit'] span#v-price").text(" - "+txt)
          $(".product button[type='submit'].try-now-button span#v-price").text(" - "+txt);   
 
           if ($(".product buy-buttons button[type='submit'] span#v-price").length) {
        $(".product buy-buttons button[type='submit'] span#v-price").text(" - "+txt)
     }
     else{
         $(".product buy-buttons button[type='submit'] div").append(`<span id="v-price"> - ${txt}</span>`)
     }
     console.log(txt);
     console.log(comparePrice);

      let finaltx = parseFloat(txt.replace('£',''));
        let comparePr = parseFloat(comparePrice.replace('£',''));

        console.log("finalPric==>"+finaltx);
          console.log("comparePric==>"+comparePr);
          if (comparePr > finaltx) {
            let discountt = comparePr - finaltx;
            let discountPercents = Math.round((discountt / comparePr) * 100);

            console.log(discountPercents + "% OFF");
            setTimeout(function(){
              $(".discount-if-any.cost-per-cup").text(discountPercents + "% OFF");
            }, 100);
          }

     });
     
     let finaltext = $(".loop-widget-purchase-option-selected").find(".loop-widget-purchase-option-price").text();
      $(".product price-list .selling-price.money").text(finaltext);
     let finaltex = parseFloat(finaltext.replace('£',''));
        let comparePri = parseFloat(comparePrice.replace('£',''));

        console.log("finalPric==>"+finaltex);
          console.log("comparePric==>"+comparePri);
          if (comparePri > finaltex) {
            let discount = comparePri - finaltex;
            let discountPercent = Math.round((discount / comparePri) * 100);

            console.log(discountPercent + "% OFF");
            // setTimeout(function(){
              $(".discount-if-any.cost-per-cup").text(discountPercent + "% OFF");
            // }, 50);
          }

    }
}
    priceAddToCart();
     document.addEventListener("variant:change", (e) => {
       setTimeout(() => {
        priceAddToCart();
        loopSub();
       }, 0);
     });
    window.addEventListener("beforeunload", function (e) {
     const labels = document.querySelectorAll('.variant-picker__option-values .block-swatch');
        if (labels.length >= 3) {
         $(".variant-picker__option-values label.block-swatch").eq(1).trigger("click"); 
        }
    });
    }
});
document.querySelectorAll(".shopify-section--faq details.accordion").forEach((el, index, allAccordions) => { // close accordions automatically when the clicked one is open
    el.addEventListener("click", function (event) {
        event.preventDefault();
        // Close all other accordions
        allAccordions.forEach((item) => {
            if (item !== this) {
                item.removeAttribute("open");
                item.setAttribute("aria-expanded", "false");
            }
        });
        // Open the clicked accordion
        this.setAttribute("open", "");
        this.setAttribute("aria-expanded", "true");
    });
});
var loadNector = setInterval(checkNectorShadow, 200);
function checkNectorShadow() {
  const host = document.querySelector('#nector-reviews');
  if (!host) return;
  const shadow = host.shadowRoot || host.attachShadow?.({ mode: 'open' });
  if (!shadow) return;
  const container = shadow.querySelectorAll('.nector-container .nector-reviews');
  const imgs = shadow.querySelectorAll('.react-multi-carousel-track .react-multi-carousel-item img');
  const shorts = shadow.querySelectorAll('select.nector-reviews-sorter');
  const button = shadow.querySelectorAll('.react-multi-carousel-list button');
  if (imgs.length > 0 || container.length > 0) {
    imgs.forEach((img, i) => {
      img.setAttribute('alt', 'Customer review image ' + (i + 1));
      img.setAttribute('loading', 'lazy');
    });
    shorts.forEach(sel => {
      sel.setAttribute('aria-label', 'Review sort dropdown');
    });
    setTimeout(function(){
    button.forEach(btn => {
      btn.setAttribute('aria-label', 'Review button');
    });
    }, 2500);
    setTimeout(() => {
     clearInterval(loadNector);
    }, 5000);
  }
}
var loadKlaviyo = setInterval(checkKlaviyo, 200);
function checkKlaviyo() {
  if ($('.needsclick.kl-private-reset-css-Xuajs1').length > 2) {    
    $('.needsclick.kl-private-reset-css-Xuajs1 img').attr("alt", "klaviyo popup image");
    setTimeout(() => {
      clearInterval(loadKlaviyo);
    }, 10000);
  }
}









// script for swap-upsell [21 jan 2026]

document.addEventListener('click', async function (event) {
  const button = event.target.closest('.upgrade-btn');
  if (!button) return;

  event.preventDefault();

  if (button.classList.contains('loading')) return;
  button.classList.add('loading');
  button.disabled = true;

  const lineKey = button.dataset.line;
  const qty = parseInt(button.dataset.qty, 10) || 1;
  const upgradeVariantId = Number(button.dataset.upgrade);
  const oldVariantId = Number(button.dataset.oldVariant);
  const gifts = JSON.parse(button.dataset.gifts || '[]');
  const sellingPlanId = button.dataset.sellingPlan
    ? Number(button.dataset.sellingPlan)
    : null;

  try {
    //  ADD UPGRADE 
    const upgradeRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: upgradeVariantId,
        quantity: qty,
        properties: {
          _swap: 'true'
        },
        ...(sellingPlanId ? { selling_plan: sellingPlanId } : {})
      })
    });

    if (!upgradeRes.ok) throw new Error('Upgrade add failed');

    //   GET CART 
   // let existingVariantIds = [];
   // if (gifts.length) {
    //  const cartRes = await fetch('/cart.js');
    //  const cart = await cartRes.json();
     // existingVariantIds = cart.items.map(item => item.variant_id);
   // }


   const cartRes = await fetch('/cart.js');
const cart = await cartRes.json();

// map variant_id → full cart item
const cartItemMap = new Map();

cart.items.forEach(item => {
  cartItemMap.set(item.variant_id, item);
});


    //  ADD GIFTS 
  for (const giftId of gifts) {
  const variantId = Number(giftId);

  const existingItem = cartItemMap.get(variantId);

  const properties = {
    _gift: 'true',
    _free_gift_swap: 'true',
    _parent_variant_id: String(upgradeVariantId),
    _parent_title: button.dataset.parentTitle || 'your subscription'
  };

  console.log('Processing gift:', {
    variantId,
    exists: !!existingItem
  });

if (existingItem) {

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: existingItem.key,
      quantity: 0
    })
  });

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties
    })
  });

  console.log('ADDING GIFT WITH PROPERTIES:', JSON.stringify(properties, null, 2));


  continue;
}


  const giftRes = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties
    })
  });

  if (!giftRes.ok) {
    console.warn('Gift skipped (likely out of stock):', variantId);
  }
}


    //  REMOVE OLD ITEM LAST
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: {
          [oldVariantId]: 0
        }
      })
    });
    // await fetch('/cart/change.js', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ id: lineKey, quantity: 0 })
    // });


    //  REFRESH CART 
    if (window.location.pathname === '/cart') {
      window.location.reload();
    } else {
      await dispatchCartChange('swap');
      document.dispatchEvent(new Event('cart:refresh'));
    }

  } catch (error) {
    console.error('Upgrade swap failed:', error);
    alert('Something went wrong while upgrading. Please try again.');
  } finally {
    button.classList.remove('loading');
    button.disabled = false;
  }
});






//remove gifts item too with main product

async function removeLinkedGifts(parentVariantId) {
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();

  const updates = {};

  cart.items.forEach(item => {

    const isFreeGift =  item.properties?._free_gift_swap === true || item.properties?._free_gift_swap === "true" ;

    if (
     isFreeGift &&
      Number(item.properties._parent_variant_id) === Number(parentVariantId)
    ) {
      updates[item.key] = 0;
    }
  
 
  });

  if (Object.keys(updates).length) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }
}






//i have made similar different button for removing main swap product here is its event handling 

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.remove-swap-item');
  if (!btn) return;

  e.preventDefault();

  const lineKey = btn.dataset.lineKey;
  const parentVariantId = btn.dataset.variantId;

  try {
    // remove gifts first
    await removeLinkedGifts(parentVariantId);

    // then remove main product
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });

    if (window.location.pathname === '/cart') {
      window.location.reload();
    } else {
      // document.dispatchEvent(new Event('cart:refresh'));
      await dispatchCartChange('swap');
      document.dispatchEvent(new Event('cart:refresh'));
    }
  } catch (err) {
    console.error('Swap remove failed', err);
  }
});



async function dispatchCartChange(baseEvent = 'custom') {
  const res = await fetch('/cart.js');
  const cart = await res.json();

  document.dispatchEvent(
    new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        cart,
        baseEvent
      }
    })
  );
}

// Swap upsell related script end

(function () {
  window.addEventListener("load", function () {
    window.__ATC_QUEUE__ = [];
    window.__ATC_BUSY__ = false;
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const url = args[0];
      if (typeof url === "string" && url.includes("/cart/add")) {
        return new Promise(async (resolve, reject) => {
          try {
            const response = await originalFetch.apply(this, args);
            const cloned = response.clone();
            const data = await cloned.json();
            document.dispatchEvent(new CustomEvent("atc:done", {
              detail: { cart: data }
            }));
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent("atc:after"));
            }, 100);
            resolve(response);
          } catch (err) {
            reject(err);
          }
        });
      }
      return originalFetch.apply(this, args);
    };
  });
})();


$("document").ready(function(){
//*****************  Collection page Load Yotpo Reviews start  *************************/ 
const wrapper = document.querySelector("#wizzy-shopify-collection-page-wrapper");
 if (wrapper) {
  const observer = new MutationObserver(() => {
    const widgets = wrapper.querySelectorAll(".yotpo-widget-instance");

    if (widgets.length > 1) {
      window.yotpoWidgetsContainer?.initWidgets();

      // Observer stop
      observer.disconnect();
    }
  });

  observer.observe(wrapper, {
    childList: true,
    subtree: true
  });

    document.body.addEventListener("click", function (e) {
      if (e.target.closest(".wizzy-facet-body")) {
        window.yotpoWidgetsContainer?.initWidgets();
        setTimeout(()=> {
          window.yotpoWidgetsContainer?.initWidgets();
        }, 500);
      }
    });

}
//*****************  Collection page Load Yotpo Reviews end  *************************/ 
});
